import React from "react";

/**
 * SkeletonCard - Loading skeleton for performance cards
 */
const SkeletonCard = () => (
  <div className="bg-white border border-[#E5E6E8] rounded-xl p-4 animate-pulse">
    <div className="flex items-center gap-3">
      <div className="flex-shrink-0">
        <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
      </div>
      <div className="flex flex-col flex-1">
        <div className="h-3 bg-gray-200 rounded w-20 mb-2"></div>
        <div className="h-6 bg-gray-200 rounded w-16"></div>
      </div>
    </div>
  </div>
);

/**
 * HeaderSkeleton - Loading skeleton for stats header bar
 */
const HeaderSkeleton = () => (
  <div className="bg-[#F8F9FB] border border-[#D6DBEA] rounded-xl p-4 flex items-center gap-6 flex-wrap animate-pulse">
    <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
    <div className="h-4 bg-gray-200 rounded w-24"></div>
    <div className="h-4 bg-gray-200 rounded w-32"></div>
    <div className="h-4 bg-gray-200 rounded w-28"></div>
    <div className="h-4 bg-gray-200 rounded w-24"></div>
    <div className="h-4 bg-gray-200 rounded w-20"></div>
  </div>
);

/**
 * SectionsSkeleton - Loading skeleton for stats sections
 */
const SectionsSkeleton = ({ rows = 2 }) => (
  <div className="space-y-6">
    {[...Array(rows)].map((_, rowIndex) => (
      <div
        key={`skeleton-row-${rowIndex}`}
        className="grid grid-cols-1 md:grid-cols-2 gap-6"
      >
        {[...Array(2)].map((_, colIndex) => (
          <div
            key={`skeleton-section-${rowIndex}-${colIndex}`}
            className="bg-white border border-[#E5E6E8] rounded-xl p-6 animate-pulse"
          >
            <div className="h-5 bg-gray-200 rounded w-32 mb-4"></div>
            <div className="space-y-3">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="flex justify-between">
                  <div className="h-4 bg-gray-200 rounded w-40"></div>
                  <div className="h-4 bg-gray-200 rounded w-16"></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
);

/**
 * StatsSkeleton - Full loading skeleton for player stats
 * Combines header, cards, and sections skeletons
 */
const StatsSkeleton = ({ cardCount = 6, sectionRows = 2 }) => (
  <>
    <HeaderSkeleton />

    {/* Performance Summary Cards Skeleton */}
    <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
      {[...Array(cardCount)].map((_, index) => (
        <SkeletonCard key={`skeleton-${index}`} />
      ))}
    </div>

    {/* Stats Sections Skeleton */}
    <SectionsSkeleton rows={sectionRows} />
  </>
);

// Export individual components for granular use
export { SkeletonCard, HeaderSkeleton, SectionsSkeleton };
export default StatsSkeleton;
